<template>
  <img id="rounded-image" src="./assets/icon-40.png">
  <HelloWorld msg="中免日上轻应用下载页面"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#rounded-image {
  margin: 30px;
  border-radius: 10px;
}
</style>